import React from "react";
import { motion } from "framer-motion";
import {
  FaBriefcase,
  FaCode,
  FaGraduationCap,
  FaMapMarkerAlt,
  FaMobileAlt,
  FaRobot,
} from "react-icons/fa";
const facts = [
  {
    label: "Focus",
    value: "React Native, React & AI",
    detail: "Mobile products · Web apps · Intelligent systems",
    marker: "01",
    Icon: FaCode,
  },
  {
    label: "Experience",
    value: "3 years in software delivery",
    detail: "Production banking and digital products",
    marker: "03",
    Icon: FaBriefcase,
  },
  {
    label: "Based in",
    value: "Cyberjaya, Malaysia",
    detail: "Available for remote and hybrid opportunities",
    marker: "MY",
    Icon: FaMapMarkerAlt,
  },
  {
    label: "Highest education",
    value: "Master of Computing (AI)",
    detail: "Research programme · UKM · In progress",
    marker: "MSc",
    Icon: FaGraduationCap,
  },
];
const About = () => (
  <section id="about" className="section">
    <p className="eyebrow">Profile / 01</p>
    <h2 className="section-title">
      Building useful products
      <br />
      with care and clarity.
    </h2>
    <div className="about-grid">
      <motion.div
        className="panel about-copy"
        initial={{ y: 12 }}
        whileInView={{ y: 0 }}
        transition={{ duration: 0.35 }}
        viewport={{ once: true, margin: "0px 0px 280px 0px" }}
      >
        <p>
          I am a software engineer with{" "}
          <strong>three years of professional experience</strong> delivering
          mobile banking and digital products. My strongest focus is{" "}
          <strong>React Native and React</strong>, with experience collaborating
          across development, quality assurance, product and design teams.
        </p>
        <p>
          Alongside production engineering, I am pursuing a{" "}
          <strong>Master of Computing</strong> in{" "}
          <strong>Artificial Intelligence</strong>. My current research,{" "}
          <strong>MIRAI</strong>, explores an LLM-based artificial-persona
          system that uses retrieval-augmented generation and embeddings to make
          responses more context-aware and meaningful.
        </p>
        <p>
          I am seeking an opportunity where I can contribute thoughtful
          front-end and mobile solutions while continuing to apply and deepen my
          AI capability.
        </p>
        <div className="about-focus-rail" aria-hidden="true">
          <div className="about-focus-node about-focus-mobile">
            <span>
              <FaMobileAlt />
            </span>
            <small>Mobile</small>
          </div>
          <div className="about-focus-node about-focus-product">
            <span>
              <FaCode />
            </span>
            <small>Product</small>
          </div>
          <div className="about-focus-node about-focus-ai">
            <span>
              <FaRobot />
            </span>
            <small>Applied AI</small>
          </div>
        </div>
        <div className="about-signal">
          <span />
          <span />
          <span />
          <span />
          <small>Always learning, always shipping.</small>
        </div>
      </motion.div>
      <div className="facts">
        {facts.map(({ label, value, detail, marker, Icon }, index) => (
          <motion.div
            className="panel fact"
            key={label}
            initial={{ x: 10 }}
            whileInView={{ x: 0 }}
            transition={{ duration: 0.35, delay: index * 0.05 }}
            viewport={{ once: true, margin: "0px 0px 280px 0px" }}
          >
            <div className="fact-content">
              <small>{label}</small>
              <b>{value}</b>
              <p className="fact-detail">{detail}</p>
            </div>
            <div className="fact-visual" aria-hidden="true">
              <span>
                <Icon />
              </span>
              <em>{marker}</em>
            </div>
            <i />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
export default About;
